import React from "react";
import Loader from "../../../components/common/Loader";
import CommonErrorBanner from "../../../components/common/CommonErrorBanner";
import Table, { TableRow } from "../../../components/common/Table/Table";
import Pagination from "../../../components/common/Table/Pagination";

interface MembersTableProps {
  displayRows: TableRow[];
  totalItems?: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (p: number) => void;
  columns: any;
  onSort: (col: string, dir: "ASC" | "DESC") => void;
  sortColumn: string;
  sortDirection: "asc" | "desc";
  loading?: boolean;
  optionsLoading?: boolean;
  error?: string | null;
  showSingleBanner?: boolean;
  updateRoleLoading?: boolean;
  paginationTestId?: string;
  paginationWrapperTestId?: string;
}

const MembersTable: React.FC<MembersTableProps> = ({
  displayRows,
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  columns,
  onSort,
  sortColumn,
  sortDirection,
  loading,
  optionsLoading,
  error,
  showSingleBanner,
  updateRoleLoading,
  paginationTestId,
  paginationWrapperTestId,
}) => {
  const renderContent = () => {
    if (showSingleBanner) return null;
    if (error) {
      return (
        <CommonErrorBanner
          heading="Internal Server Error"
          messageInfo={
            "The server encountered an issue and was unable to complete your request.\nPlease try again later."
          }
        />
      );
    }
    if (loading || optionsLoading) {
      return (
        <div className="flex justify-center items-center min-h-[200px]">
          <Loader />
        </div>
      );
    }
    if (displayRows.length === 0) {
      return null;
    }
    return (
      <div className="relative">
        {updateRoleLoading && (
          <div className="absolute inset-0 flex justify-center items-center bg-white/60 z-10">
            <Loader />
          </div>
        )}
        <Table
          columns={columns}
          rows={displayRows}
          onSort={onSort}
          sortColumn={sortColumn}
          sortDirection={sortDirection.toUpperCase() as "ASC" | "DESC"}
        />
      </div>
    );
  };

  return (
    <>
      {renderContent()}
      <div
        className="mt-4! left-0 mobile:relative mobile:left-[30px]"
        data-testid={paginationWrapperTestId}
      >
        <Pagination
          data-testid={paginationTestId}
          totalItems={totalItems ?? 0}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />
      </div>
    </>
  );
};

export default MembersTable;
